var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMember({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#969696",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0927 5C9.40316 5 7.22289 7.18027 7.22289 9.86976C7.22289 11.6087 8.13436 13.1348 9.50562 13.9963C8.5059 14.2843 7.61839 14.7676 6.89133 15.4841C5.58034 16.7761 4.9502 18.6693 4.9502 21.0489C4.9502 21.6012 5.39791 22.0489 5.9502 22.0489C6.50248 22.0489 6.9502 21.6012 6.9502 21.0489C6.9502 19.006 7.48708 17.705 8.2952 16.9086C9.10627 16.1093 10.3501 15.6607 12.0926 15.6607C13.8351 15.6607 15.079 16.1093 15.8901 16.9086C16.6982 17.705 17.2351 19.006 17.2351 21.0489C17.2351 21.6011 17.6828 22.0489 18.2351 22.0489C18.7874 22.0489 19.2351 21.6012 19.2351 21.0489C19.2351 18.6692 18.6049 16.7761 17.2939 15.4841C16.5669 14.7676 15.6794 14.2843 14.6797 13.9963C16.0509 13.1348 16.9624 11.6087 16.9624 9.86976C16.9624 7.18027 14.7822 5 12.0927 5ZM9.22289 9.86976C9.22289 8.28484 10.5077 7 12.0927 7C13.6776 7 14.9624 8.28484 14.9624 9.86976C14.9624 11.4547 13.6776 12.7395 12.0927 12.7395C10.5077 12.7395 9.22289 11.4547 9.22289 9.86976Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.788c686ab516c9065f6e4d59ed779881.svg";
export { ForwardRef as ReactComponent };